import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";
import moment from "moment";

export function getTraining(dispatch) {
  baseAxios
    .get(`/training/gettrainingall`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_LISTTRAINING", data: respon.data });
    })
    .catch(errorHandler);
}

export function verifikasiTraining(data) {
  baseAxios
    .patch(`/training/respontraining`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getKpi1Training(dispatch, data) {
  baseAxios
    .get(
      `/training/getgrafiktraining?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then(async (respon) => {
      dispatch({ type: "SET_KPI1TRAINING", data: respon.data });
    })
    .catch(errorHandler);
}

export function getPembinaan(dispatch) {
  baseAxios
    .get(`/pembinaan/getpembinaanall`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_LISTPEMBINAAN", data: respon.data });
    })
    .catch(errorHandler);
}

export function verifikasiPembinaan(data) {
  baseAxios
    .patch(`/pembinaan/responpembinaan`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getKpi2Pembinaan(dispatch, data) {
  baseAxios
    .get(
      `/pembinaan/getgrafikpembinaan?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then(async (respon) => {
      dispatch({ type: "SET_KPI2PEMBINAAN", data: respon.data });
    })
    .catch(errorHandler);
}

export function tambahTraining(data) {
  baseAxios
    .post(`/training/ajukantraining`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function editTraining(data) {
  baseAxios
    .patch(`/training/ajukantrainingulang`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getCalendarTraining(dispatch) {
  baseAxios
    .get("/training/gettrainingcalendar", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_CALENDAR", data: respon.data });
    })
    .catch(errorHandler);
}

export function importAbsensi(data) {
  // console.log(data);
  baseAxios
    .post(`/training/importexcelabsensi`, data, {
      headers: {
        token: localStorage.getItem("tokenjti"),
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (ProgressEvent) => {
        console.log(
          parseInt(
            Math.round((ProgressEvent.loaded * 100) / ProgressEvent.total),
          ),
        );
        console.log(ProgressEvent);
      },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export async function getAbsensi(dispatch, data) {
  try {
    let response = await baseAxios.get(
      `/training/getabsensiall?limit=${data.limit}&page=${data.page}&dari=${data.dariTgl}&sampai=${data.smpTgl}&search=${data.search}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    );
    dispatch({ type: "SET_LISTABSENSI", data: response.data });
    return response.status;
  } catch (error) {
    return error.response;
  }
}

export function exportAbsensi(data) {
  Swal.fire({
    title: "Export Data Excel",
    text: `Apakah anda yakin export data absensi dari ${moment(
      data.dariTgl,
    ).format("DD MMMM YYYY")} sampai ${moment(data.smpTgl).format(
      "DD MMMM YYYY",
    )} ?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Ya, Export",
    cancelButtonText: "Batal",
    allowOutsideClick: () => !Swal.isLoading(),
    showLoaderOnConfirm: true,
    preConfirm: () => {
      return new Promise((resolve) => {
        baseAxios
          .get(
            `/training/exportabsenbydate?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
            {
              headers: { token: localStorage.getItem("tokenjti") },
              responseType: "blob",
            },
          )
          .then((respon) => {
            // console.log(respon, "KKKK");
            const url = window.URL.createObjectURL(new Blob([respon.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Data absen ${moment(data.dariTgl).format(
                "DD MMMM YYYY",
              )}-${moment(data.smpTgl).format("DD MMMM YYYY")}.xlsx`,
            );
            document.body.appendChild(link);
            link.click();
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Export Berhasil",
              text: "Data berhasil diexport.",
            });
            resolve();
          })
          .catch((err) => {
            Swal.showValidationMessage(`Gagal data: ${err}`);
            resolve();
          });
      });
    },
  });
}

export function getKpi3Absensi(dispatch, data) {
  baseAxios
    .get(
      `/training/getgrafikabsensi?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then(async (respon) => {
      dispatch({ type: "SET_KPI3ABSENSI", data: respon.data });
    })
    .catch(errorHandler);
}

export function getAbsensiDashboard(dispatch, data) {
  baseAxios
    .get(
      `/training/getgrafikabsensi?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then(async (respon) => {
      dispatch({ type: "SET_KPIABSENSIDASHBOARD", data: respon.data });
    })
    .catch((err) => {
      console.log(err);
    });
  // .catch(errorHandler);
}

export function deleteTraining(data) {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      // console.log(data.visitId);
      baseAxios
        .delete("/training/deletetraining", {
          data: { trainingId: data },
          headers: { token: localStorage.getItem("tokenjti") },
        })
        .then(async (respon) => {
          Swal.fire({
            title: respon.data.message,
            icon: "success",
          }).then(() => {
            window.location.reload();
          });
        })
        .catch(errorHandler);

      // Swal.fire("Deleted!", "Your file has been deleted.", "success");
    }
  });
}

export function getAllEvent(dispatch) {
  baseAxios
    .get(`/training/getallevent`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_ALLEVENT", data: respon.data });
    })
    .catch(errorHandler);
}

export function getAllEventCalendar(dispatch) {
  baseAxios
    .get(`/training/getalleventcalendar`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_ALLEVENTCALENDAR", data: respon.data });
    })
    .catch(errorHandler);
}

export function setJumlahKaryawan(data) {
  baseAxios
    .post(`/training/setjumlahkaryawan`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getJmlKaryawan(dispatch) {
  baseAxios
    .get(`/training/getjumlahkaryawan`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_JMLKARYAWAN", data: respon.data.data });
    })
    .catch(errorHandler);
}

export async function getBelumAbsen(dispatch, data) {
  try {
    let response = await baseAxios.get(
      `/training/getlistbelumabsen?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    );
    dispatch({ type: "SET_BELUMABSEN", data: response.data });
    return response.status;
  } catch (error) {
    return error.response;
  }
}

export async function getAbsensiManual(dispatch, data) {
  try {
    let response = await baseAxios.get(
      `/training/getlistabsenmanual?limit=${data.limit}&page=${data.page}&dari=${data.dariTgl}&sampai=${data.smpTgl}&search=${data.search}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    );
    dispatch({ type: "SET_LISTABSENSIMANUAL", data: response.data });
    return response.status;
  } catch (error) {
    return error.response;
  }
}
export async function createAbsenManual(data) {
  try {
    let response = await baseAxios.post(`/training/createabsenmanual`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    });
    return response;
  } catch (error) {
    return error.response;
  }
}
export async function editAbsenManual(data) {
  try {
    let response = await baseAxios.patch(`/training/editabsenmanual`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    });
    return response;
  } catch (error) {
    return error.response;
  }
}
export async function editKategoriAbsenBackoffice(data) {
  try {
    let response = await baseAxios.patch(
      `/training/editkategoriabsenbackoffice`,
      data,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    );
    return response;
  } catch (error) {
    return error.response;
  }
}
export async function deleteAbsenManual(data) {
  try {
    let response = await baseAxios.patch(`/training/deleteabsenmanual`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    });
    return response;
  } catch (error) {
    return error.response;
  }
}
export async function listKategoriAbsen(dispatch) {
  try {
    let response = await baseAxios.get(`/training/listkategoriabsen`, {
      headers: { token: localStorage.getItem("tokenjti") },
    });
    dispatch({ type: "SET_LIST_KATEGORI_ABSEN", data: response.data });
    return response;
  } catch (error) {
    return error.response;
  }
}

export function exportAbsensiPdf(data) {
  Swal.fire({
    title: "Export Data PDF",
    text: `Apakah anda yakin export data absensi bulan ${moment(
      data.dariTgl,
    ).format("MMMM YYYY")}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Ya, Export",
    cancelButtonText: "Batal",
    allowOutsideClick: () => !Swal.isLoading(),
    showLoaderOnConfirm: true,
    preConfirm: () => {
      return new Promise((resolve) => {
        baseAxios
          .get(
            `/training/exportabsenbydatepdf?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
            {
              headers: { token: localStorage.getItem("tokenjti") },
              responseType: "blob",
            },
          )
          .then((respon) => {
            // console.log(respon, "KKKK");
            const url = window.URL.createObjectURL(new Blob([respon.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Data absen ${moment(data.dariTgl).format("MMMM YYYY")}.pdf`,
            );
            document.body.appendChild(link);
            link.click();
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Export Berhasil",
              text: "Data berhasil diexport.",
            });
            resolve();
          })
          .catch((err) => {
            Swal.showValidationMessage(`Gagal data: ${err}`);
            resolve();
          });
      });
    },
  });
}
